import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppRoutes, isClientOnboarding, isClientRecovery } from '@mri-platform/dsg/core';
import { FeatureFlags } from '@mri-platform/shared/core';

interface RouteData {
  featureFlags: FeatureFlags;
  hasDashboards: boolean;
}

@Component({
  template: ` <h1 class="mri-heading mri-heading--3 mri-mv-medium mri-ml-large">Welcome to {{ title }}!</h1> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class HomePageComponent {
  @HostBinding('attr.data-testid') testId = 'HomePageComponent';
  title: string;
  constructor(titleService: Title, router: Router, route: ActivatedRoute) {
    this.title = titleService.getTitle();
    const { featureFlags, hasDashboards } = route.snapshot.data as RouteData;
    const goToCommandCenter = !!featureFlags?.commandCenter;
    const defaultRoute = goToCommandCenter ? AppRoutes.CommandCenter.path : AppRoutes.Dashboards.path;

    // Explicit redirect to the default page
    // Historically, this was to solve issue caused when switching client which will refresh the whole component
    // but now, this also serves the purpose to redirect users to the Command Center page if the feature flag is enabled, instead of the dashboards page.
    if (route.snapshot.queryParams[isClientOnboarding] || route.snapshot.queryParams[isClientRecovery]) {
      router.navigate([AppRoutes.ClientOnboardConfig.path]);
    } else if (goToCommandCenter || hasDashboards) {
      router.navigate([defaultRoute]);
    }
  }
}
